export const environment = {
  production: true,
  apiUrl: 'https://client-api.gabadoo.com/v1',
  stripePricingTableId: 'prctbl_1LTQDKCsQZdYVh8teRNw44wg',
  stripePricingTableIdForSubscribedUser: 'prctbl_1LTQFxCsQZdYVh8tpDiWkBec',
  stripeTestPublishedKey: 'pk_test_51KbjW4CsQZdYVh8t4IUugL6z3wFB2VtInTYbL3ScLVwZRPl3CaFW2OlptCctyBQ71Y3CMPKY9aKWe8o9Cwe6jcdC00WgStZSt9',
  stripePublishedKey: 'pk_live_51KbjW4CsQZdYVh8tDsSxXBIVuiTeJfgWv8RviKSzauc4o5ibLnW5Di03axe9uLVsRYBZ1iEHPHOG7azMUHQodD9N00ZwcSxzCj',
  googleAnalyticsKey: 'G-KSMC5Q0BEH',
};
